
import React from 'react';

interface BOPIComponent extends React.FC {
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * BOPI - Buy Online Pickup In Store
 * KPI information component
 */
const BOPI: BOPIComponent = () => {
  return (
    <></>
  );
};

BOPI.actionTitle = 'Manage In My Store';
BOPI.actionHyperlink = 'https://acenet.aceservices.com/my-store';

export default BOPI;
